import { render, staticRenderFns } from "./classical-attendant-exam-questions.vue?vue&type=template&id=74aa92d3&scoped=true"
import script from "./classical-attendant-exam-questions.vue?vue&type=script&lang=js"
export * from "./classical-attendant-exam-questions.vue?vue&type=script&lang=js"
import style0 from "./classical-attendant-exam-questions.vue?vue&type=style&index=0&id=74aa92d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aa92d3",
  null
  
)

export default component.exports